module.exports = __webpack_public_path__ + "img/360-produktion-svarv-3.3951a857.jpg";